import {changeNestedValue} from "@Common/utils/arr-path";

export const onSaved = (m1, total) => !m1.module?.onSaved ? total : changeNestedValue(total, ["onSaveds"], (_) => [
    ..._??[],
    m1.module.onSaved,
]);
